import { refetchData } from 'actions'
import config from 'config'
import { METHODS } from 'constants.js'
import * as dateMenuSelectors from 'menu/DateMenu/selectors'
import { createLogic } from 'redux-logic'
import type { State } from 'store/types'
import { fetchAction } from 'utils'

import * as actions from './actions'
import { FETCH_USER, PATCH_USER, SET_USE_LOCAL_CURRENCY } from './constants'

const fetchUser = createLogic<State>({
  type: FETCH_USER,
  latest: true,

  async process({ getState }, dispatch, done) {
    const baseRequestParams = dateMenuSelectors.baseRequestParams(getState())

    try {
      const response = await fetchAction(config.api.user, baseRequestParams)

      dispatch(actions.userSuccess(response.data))
    } catch (e) {
      dispatch(actions.userError())
    }

    done()
  },
})

const patchUser = createLogic<State, {}>({
  type: [PATCH_USER, SET_USE_LOCAL_CURRENCY],
  latest: true,

  async process({ action }, dispatch, done) {
    try {
      await fetchAction(config.api.user, action.payload, METHODS.PATCH)

      if (action.type === SET_USE_LOCAL_CURRENCY) {
        dispatch(refetchData())
      }
    } catch (error) {
      // Not interested
    }

    done()
  },
})

export default [fetchUser, patchUser]
